/**
 * @param {import('../../../../../type-definitions').Refinement} refinement - Search result
 * @param {import('../../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @returns {string} selected generic HTML
 */
export default (refinement, refinementURLBuilder) => {
    if (refinement.options.length === 0) {
        return '';
    }

    const selectedOptions = refinement.options.filter(option => option.selected);

    return selectedOptions
        .map(
            option => `
                <li class="value">
                    <div class="value-inner">
                        <span role="link" tabindex="0" class="refinement-relax"
                            data-href="${refinementURLBuilder.getRefinementValueRemoveURL(refinement.id, option.value)}"
                            aria-label="${window.Resources.SEARCH_REFINEMENT_REMOVE}"
                            data-refinement-id="${refinement.id}" data-is-selected="true"
                            data-refinement-value="${encodeURIComponent(option.value)}">
                            <span>${option.name}</span>
                            <i class="icon icon-close" aria-hidden="true"><!-- icon --></i>
                        </span>
                    </div>
                </li>
            `
        )
        .join('');
};
